import { render } from "./ConfiguracionBusquedaExcel.vue?vue&type=template&id=32407fc0"
import script from "./ConfiguracionBusquedaExcel.vue?vue&type=script&lang=js"
export * from "./ConfiguracionBusquedaExcel.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__